/**************************************************************************************************/
/*   File: /src/app/shared/components/messages/messages.component.ts                              */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Friday February 22nd 2019                                                      */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Tue May 14 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import { Component, Input, OnInit } from '@angular/core';
import { transition, trigger, style, animate, query, stagger, animateChild } from '@angular/animations';
import { Store } from '@ngrx/store';

import * as fromActions from '../../../stores/actions';
import * as fromStates from '../../../stores/states';
import * as fromEnums from '../../enums';
import * as fromModels from '../../models';

/**
 * The message box component
 */
@Component({
  selector: 'nwpl-frnt-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  animations: [
    trigger('items', [
      transition(':enter', [
        style({ transform: 'scale(0.5)', opacity: 0 }),  // initial
        animate('1s cubic-bezier(.8, -0.6, 0.2, 1.5)',
          style({ transform: 'scale(1)', opacity: 1 }))  // final
      ]),
      transition(':leave', [
        style({ transform: 'scale(1)', opacity: 1, height: '*' }),
        animate('1s cubic-bezier(.8, -0.6, 0.2, 1.5)',
          style({
            transform: 'scale(0.5)', opacity: 0,
            height: '0px', margin: '0px'
          }))
      ])
    ]),
    trigger('list', [
      transition(':enter', [
        query('@items', stagger(300, animateChild()), { optional: true })
      ])
    ])
  ]
})
export class MessagesComponent implements OnInit {

  /**
   * The message to show
   */
  @Input() messages: fromModels.Message[];

  /**
   * The position
   */
  @Input() position: fromEnums.MessagePositionEnum;

  /**
   * The show from external
   */
  @Input() show: boolean;

  /**
   * The message position
   */
  MessagePosition = fromEnums.MessagePositionEnum;


  /**
   * The constructor
   */
  constructor(private store: Store<fromStates.fromRoot.RootState>) { }

  /**
   * The ng on init hook
   */
  ngOnInit() {
  }

  /**
   * On closed event
   * @param message The message
   */
  onClosed(message: fromModels.Message) {
  
    this.store.dispatch(
      new fromActions.fromMessages.RemoveMessageAction(
        {
          message: message
        }
      )
    );
  }
}
